import { createFileRoute } from '@tanstack/react-router'
import { DocumentEditPage } from '@/features/documents/editor'

export const Route = createFileRoute('/documents_/$documentId/edit')({
  component: DocumentEditPage,
})
